export const vw = (percent: number) => {
  const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  return (percent * w) / 100;
};

export function vwDSizes(num: number) {
  return vw((num / 1280) * 100);
}

export function vwMSizes(num: number) {
  return vw((num / 375) * 100);
}
